import React, { ReactNode } from 'react';
import * as S from './ProfileLayout.styled';
import { Footer } from '@/components/Footer/Footer';
import { Header } from '@/components/Header';
import { PageTopControls } from '@/components/PageTopControls';
import { TabBar } from '@/components/TabBar/TabBar';
import { MobileProfileOverview } from '@/features/Profile/core/MobileProfileOverview';
import { ProfileNav } from '@/features/Profile/core/ProfileNav';
import { UserSummaryCard } from '@/features/Profile/core/UserSummaryCard';
import { useResponsive } from '@/hooks/useResponsive';

type ProfileLayoutProps = {
  children: ReactNode;
};

export function ProfileLayout({ children }: ProfileLayoutProps) {
  const { isDesktop } = useResponsive();

  return (
    <S.Page>
      {isDesktop && (
        <PageTopControls>
          <Header />
        </PageTopControls>
      )}

      {!isDesktop && <MobileProfileOverview />}

      <S.Main>
        {isDesktop && (
          <S.Sidebar>
            <UserSummaryCard />
            <ProfileNav />
          </S.Sidebar>
        )}

        <S.Content>{children}</S.Content>
      </S.Main>

      {isDesktop ? <S.DesktopFooter hasRegions={false} /> : <Footer />}
      {!isDesktop && <TabBar />}
    </S.Page>
  );
}
